import { LogoutOutlined, UsbOutlined, UserOutlined, InfoCircleOutlined, ShopOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import React from 'react';
import { isAuthenticated, getLoginUser } from '../../utils/session'
import { logout } from '../../utils/session';
import { withRouter } from '../../utils/router'
import { OBJECT_STORAGE_URL } from '../../utils/constants'

class ProfileHeader extends React.Component {
    state = {
        avatar: OBJECT_STORAGE_URL.DEFAULT_USER_AVATAR,
    }

    logout() {
        logout();
        this.props.router.navigate(this.props.router.location.pathname);
    }


    render() {
        const user = getLoginUser();
        let notLogin = (
            <Button onClick={() => this.updatePage('/login')} type="primary" shape="round" style={{ height: "30px", marginTop: "10px", color: "#03b8cf", backgroundColor: "#ddf3f5" }}>登录</Button>
        );
        const items = [
            {
                label: <span style={{ color: '#666' }}>{`你好 ${user.username}`}</span>,
                key: '0',
            }, {
                type: 'divider',
            }, {
                label: <a href="/manage"><ShopOutlined />&nbsp;我的空间</a>,
                key: '5',
            }, {
                type: 'divider',
            }, {
                label: <a href="/profile/info"><UserOutlined />&nbsp;个人中心</a>,
                key: '1',
            }, {
                label: <a href="/profile/update"><InfoCircleOutlined />&nbsp;更新信息</a>,
                key: '2',
            }, {
                label: <a href="/profile/password"><UsbOutlined />&nbsp;修改密码</a>,
                key: '3',
            }, {
                label: <span onClick={() => this.logout()}><LogoutOutlined />&nbsp;退出登录</span>,
                key: '4',
            }
        ];

        let login = (
            <Dropdown menu={{ items }}>
                <img style={{ width: "30px", height: "30px" }} src={user.avatar || OBJECT_STORAGE_URL.DEFAULT_USER_AVATAR} alt="" />
            </Dropdown>
        );
        return (
            <div id='headerbar' style={{ display: "flex", alignItems: "center" }}>
                <div style={styles.logo} onClick={() => this.props.router.navigate('/')}>
                    <img style={styles.img} src={'/logo.png'} alt="" />
                    <span style={styles.text}>元纹</span>
                </div>
                <div style={{ flexGrow: '1', overflow: "hidden", whiteSpace: "nowrap" }}>
                </div>
                <div style={{ width: "60px", flexGrow: '0', lineHeight: '64px', textAlign: 'right' }}>
                    {isAuthenticated() ? login : notLogin}
                </div>
            </div >
        )
    }
}

const styles = {
    logo: {
        height: '50px',
        width: '150px',
        flexGrow: '0',
        padding: '4px',
        fontWeight: 'bolder',
        fontSize: 'large',
        textAlign: 'left',
        cursor: 'pointer',
        float: 'left',
        display: 'table',
    },
    img: {
        margin: '0 5px 0 0',
        height: '40px',
        width: '40px',
        display: 'table-cell',
    },
    text: {
        fontSize: '25px',
        color: '#55cd53',
        display: 'table-cell',
        lineHeight: '25px',
        verticalAlign: 'middle',
    }
}

export default withRouter(ProfileHeader)